import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

import { QUERY_CLIENT_OPTIONS } from '@/constants'

/**
 * Клиент создаётся в состоянии, а не в модуле.
 *
 * Модульный синглтон переживает горячую перезагрузку и в тестах утекает
 * между кейсами: кэш одного теста виден следующему. Внутри useState
 * инстанс живёт ровно столько же, сколько дерево.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: QUERY_CLIENT_OPTIONS,
          mutations: { retry: 0 },
        },
      }),
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
